import { Injectable } from "@angular/core";
import { environment } from "../../../../environments/environment";
import { HttpClient } from "@angular/common/http";
import { map, Observable } from "rxjs";
import { ProviderService, ProviderServicePayload } from "../../models/provider/provider-service.model";

@Injectable({
    providedIn: 'root'
})
export class ProviderServiceService {

    constructor(private http: HttpClient) {}

    getByProvider(providerGuid: string): Observable<ProviderService[]> {
        const url = `${environment.providerService.root}/byproviderguid/${providerGuid}`;
        return this.http.get<{providerServices: ProviderService[]}>(url, { withCredentials: true }).pipe(
            map(response => response.providerServices)
        );
    }

    getByGuid(providerGuid: string, providerServiceGuid: string): Observable<ProviderService> {
        const url = `${environment.providerService.root}/${providerServiceGuid}`;
        return this.http.get<{providerService: ProviderService}>(url, { withCredentials: true }).pipe(
            map(response => response.providerService)
        );
    }

    create(providerGuid: string, payload: ProviderServicePayload): Observable<ProviderService> {
        const url = `${environment.providerService.root}`;
        return this.http.post<ProviderService>(url, { ...payload, providerGuid }, { withCredentials: true });
    }

    update(providerGuid: string, providerServiceGuid: string, payload: Partial<ProviderServicePayload>): Observable<ProviderService> {
        const url = `${environment.providerService.root}/${providerServiceGuid}`;
        return this.http.put<ProviderService>(url, payload, { withCredentials: true });
    }

    delete(providerGuid: string, providerServiceGuid: string): Observable<void> {
        const url = `${environment.providerService.root}/${providerServiceGuid}`;
        return this.http.delete<void>(url, { withCredentials: true });
    }

    toggleActive(providerGuid: string, providerServiceGuid: string): Observable<ProviderService> {
        const url = `${environment.providerService.root}/${providerServiceGuid}/toggle-active`;
        return this.http.patch<ProviderService>(url, {}, { withCredentials: true });
    }
}
